module.exports = __webpack_public_path__ + "img/version_update_bg.89506311.png";